import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('LoadPointFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getNewLoadPoint: function () {
            return $http.get(settings.ApiURL + settings.LoadPointURL + "/newloadpoint");
        },
        getLoadPointList: function () {
            return $http.get(settings.ApiURL + settings.LoadPointURL);
        },        
        getLoadPointDetails: function (id) {
            return $http.get(settings.ApiURL + settings.LoadPointURL + "/" + id);
        },
        saveLoadPoint: function (loadPoint) {
            return $http.put(settings.ApiURL + settings.LoadPointURL, loadPoint);
        },        
        getCountryList: function () {
            return $http.get(settings.ApiURL + settings.MasterDataURL + "/countries/0");
        },
        deleteLoadPoint: function (id) {
            return $http.delete(settings.ApiURL + settings.LoadPointURL + "/" + id);
        },
        getloadLocationGroup: function() {
            return $http.get(settings.ApiURL + settings.LoadPointURL + "/loadlocationgroup");
        },
        getProductDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/dropdown/0");
        },
        getLoadPointTankById: function (id, loadPointId) {
            return $http.get(settings.ApiURL + settings.LoadPointTankUrl + "/" + id + "/" + loadPointId);
        },
    };
}]);

app.controller('LoadPointController', function ($q, $scope, LoadPointFactory, CompanyFactory, $rootScope, settings, masterFactory,$uibModal,ProductFactory) {

    $rootScope.pageTitle = "Load Point";    
    $scope.loadPoints = [];
    $scope.companies = [];
    $scope.nonPrintCompanies = [];
    $scope.loadPoint = {};
    $scope.newloadPoint = {};
    $scope.error = "";
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.pageSize = 20;
    $scope.loadLocation = [];
    $scope.productDropdown = [];
    $scope.deletedLoadPointTanks = [];

    $scope.popupOptionsBulkPlantTankGrid = {
        width: 350,
        height: 150,
        fullScreen: false,
        shading: true,
        showTitle: true,
        dragEnabled: false,
        closeOnOutsideClick: true,
        bindingOptions: {
            visible: 'popupVisible',
        }
    };
    $scope.filterOptions = {
        ProductNumber: null, ProductName: null, ProductGroup: null,
        GridPagerOptions: { PageIndex: 0, PageSize: 20, TotalPages: null }
    };
    // Initialization - this runs on load
    var init = function (pageIndex) {
        masterFactory.verifyAuthentication();
        
        $('#loadingModal').modal({ backdrop: 'static' });
        $q.all([
            LoadPointFactory.getLoadPointList().success(function (data) {
                $scope.loadPoints = data;
                $scope.refreshGrid(0);                
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            }),
            LoadPointFactory.getNewLoadPoint().success(function (data) {
                $scope.newloadPoint = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            masterFactory.getCompanies(1).success(function (data) {
                $scope.companies = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            LoadPointFactory.getCountryList().success(function (data) {
                $scope.countries = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            CompanyFactory.getNonPrintCompanyList(1).success(function (data) {
                $scope.nonPrintCompanies = data;
            }).error(function (data) {
                masterFactory.setError(status, data, $scope);
            }),
            LoadPointFactory.getloadLocationGroup().success(function (data) {
               $scope.loadLocation = data;
            }).error(function (data) {
                masterFactory.setError(status, data, $scope);
            }),
            ProductFactory.getFilteredProductList($scope.filterOptions).success(function (data) {
                $scope.productDropdown = data.ProductListVM;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            })
        ]).then(function () {
        });
    };

    var getLoadPoint = function (id) {
        LoadPointFactory.getLoadPointDetails(id).success(function (data) {
            $scope.loadPoint = data;
            $scope.refreshBulkPlantTankGrid();
            $scope.isBulkPlant = $scope.loadPoint.LoadLocationGroup == 1;
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
            $scope.isBulkPlant = false;
        });
    };

    // Rendering Grids
    $scope.refreshGrid = function (PageIndex) {   
        $scope.isBulkPlant = false;     
        $('#gridloadPoint').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.loadPoints,
                    type: 'array',
                    key: 'Id'
                }
            },            
            noDataText: "No Load Points Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            contentReadyAction: grdReadyAction,
            selection: { mode: 'single' },
            paging: {
                pageSize: $scope.pageSize,
                pageIndex: PageIndex
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: true
            },
            groupPanel: {
                visible: false,
            },
            columns: [
               {
                   caption: 'Load Point No',
                   dataField: 'Number',
                   cssClass: 'Number',
                   dataType: 'string',
                   alignment: 'center',
                   width: 100
               },
               {
                   caption: 'Load Point Name',
                   dataField: 'Name1',
                   cssClass: 'Name1',
                   dataType: 'string',
                   alignment: 'center',
                   cellTemplate: function (container, options) {                       
                       $('<span />').text(options.data.Name1).append("</br>").appendTo(container);
                       container.addClass('grid-cell-align-left');
                       $('<span />').text(options.data.Name2).append("</br>").appendTo(container);
                       container.addClass('grid-cell-align-left');                       
                   }
               },
               {
                   caption: 'Load Point Address',
                   dataField: 'Address',
                   cssClass: 'Address',
                   dataType: 'string',
                   alignment: 'center',
                   cellTemplate: function (container, options) {
                       var postcodecity ="";
                       if (options.data.Postcode != null) postcodecity = postcodecity + options.data.Postcode + " ";
                       if (options.data.City != null) postcodecity = postcodecity + options.data.City;
                       $('<span />').text(options.data.Address).append("</br>").appendTo(container);
                       container.addClass('grid-cell-align-left');
                       $('<span />').text(postcodecity).append("</br>").appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    getLoadPoint(selectedRowsInfo.selectedRowsData[0].Id);
                }
                else {
                    $scope.loadPoint = angular.copy($scope.newloadPoint);
                    $scope.isBulkPlant = false;
                }
                
                $scope.isFormVisible = true;
                $scope.isDeleteVisible = true;
                ToggleYellowToGreen();
                $rootScope.pageTitle = "Load Points";
            }

        });
    };

    $scope.onLoadLocationGroupChange = function(){
        $scope.isBulkPlant = $scope.loadPoint.LoadLocationGroup == 1;
    }

    $scope.refreshBulkPlantTankGrid = function () {
        $scope.isLoadPointTankSelected = false;
        $scope.deletedLoadPointTanks = [];
        $('#gridBulkPlantTank').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.loadPoint.LoadPointTanks,
                    type: 'array',
                    key: 'Id'
                }
            },
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            columnAutoWidth: true,
            height: 230,
            selection: { mode: 'single' },
            editing: {
                editEnabled: false,
                insertEnabled: false
            },
            paging: {
                pageSize: 10
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: false
            },
            groupPanel: {
                visible: false
            },
            columns: [
                {
                    caption: 'Tank ID',
                    dataField: 'TankId',
                    dataType: 'string',
                    alignment: 'center',
                    width: '50%'
                },
                {
                    caption: 'Product',
                    dataField: 'ProductName',
                    dataType: 'string',
                    alignment: 'center',
                    width: '50%'
                },
                {
                    width: 100,
                    alignment: 'center',
                    cellTemplate: function (container, options) {
                        $('<a/>').addClass('dx-link')
                            .text('Delete')
                            .on('dxclick', function () {
                                if ($scope.loadPoint.LoadPointTanks.length > 1) {
                                    $("#gridBulkPlantTank").dxDataGrid("instance").removeRow(options.rowIndex);
                                    $scope.deletedLoadPointTanks.push(options.data);
                                }
                                else {
                                    $scope.popupVisible = true;
                                }
                            })
                            .appendTo(container);
                    }
                }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData.length > 0 && !selectedRowsInfo.selectedRowsData[0].Changed) {
                    //$('#loadingModal').modal({ backdrop: 'static' });
                    LoadPointFactory.getLoadPointTankById(selectedRowsInfo.selectedRowsData[0].Id, $scope.loadPoint.Id).success(function (data) {
                        $scope.loadPointTank = data;
                        $scope.isLoadPointTankSelected = true;
                        ProductFactory.getProductDetails($scope.loadPointTank.ProductId).success(function (data) {
                            $scope.loadPointTank.ProductName = data.ProductName;
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        });

                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                        $scope.isLoadPointTankSelected = false;
                    }).finally(function () {
                        //$('#loadingModal').modal('hide');
                    });
                }
                else if (selectedRowsInfo.selectedRowsData.length > 0 && selectedRowsInfo.selectedRowsData[0].Changed) {
                    $scope.loadPointTank = selectedRowsInfo.selectedRowsData[0];
                    $scope.isLoadPointTankSelected = true;
                    $rootScope.user.ProductId = 0;
                    $rootScope.user.ProductName= '';
                }
                else {
                    $scope.loadPointTank = {};
                    $scope.isLoadPointTankSelected = false;
                }
            }
        });
    };

    // Button click functions and submit form function
    $scope.addNewEntity = function () {
        $rootScope.pageTitle = "New Load Point";
        $scope.isFormVisible = true;
        $scope.isDeleteVisible = false;
        $scope.loadPoint = angular.copy($scope.newloadPoint);
        $scope.loadPoint.LoadPointTanks = [];   
        $scope.refreshBulkPlantTankGrid();     
        ToggleGreenToYellow();
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            LoadPointFactory.deleteLoadPoint($scope.loadPoint.Id).success(function (data) {
                LoadPointFactory.getLoadPointList().success(function (data) {
                    var dataGrid = $('#gridloadPoint').dxDataGrid('instance');
                    var pageIndex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    $scope.loadPoints = data;
                    $scope.cancelForm();
                    $scope.refreshGrid(pageIndex);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Load Point successfully' });
                });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }
    };

    $scope.cancelForm = function () {
        var dataGrid = $('#gridloadPoint').dxDataGrid('instance');
        dataGrid.clearSelection();
        $scope.isFormVisible = false;        
        $scope.loadPointForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    }

    $scope.reset = function (type) {
        if (type == 'update') { 
            getLoadPoint($scope.loadPoint.Id);
        }
        else {
            angular.copy($scope.newloadPoint, $scope.loadPoint);
            $scope.isBulkPlant = false;
            $scope.loadPoint.LoadPointTanks = [];
        }

        $scope.loadPointForm.$setPristine();
        $scope.loadPointForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Load Point details were reset' });
    };

    $scope.submitForm = function () {
        $scope.error = '';
        if ($scope.loadPointForm.$valid) {
            $scope.saveloadPoint();
            $scope.loadPointForm.submitted = false;
        } else {
            $scope.loadPointForm.submitted = true;
        }
    };

    var scrollToTop = function () {
         $('#LoadPointDetailsDiv').scrollTop(0);
    }

    $scope.saveloadPoint = function () : void {
        var pageindex;
        var id = -1;
        if($scope.loadPoint.LoadLocationGroup != 1){
            $scope.loadPoint.LoadPointTanks.forEach(function (loadPointTank) {
                loadPointTank.Deleted = true;
            });
        }

        $scope.closeModelStateErrors();
        if($scope.loadPoint.LoadLocationGroup == 1 && $scope.loadPoint.LoadPointTanks.length == 0)
        {
            $scope.modelState[$scope.modelState.length] = "At least one Bulk Tank is required to save the Load Point.";
            scrollToTop();
            return;
        }

        $scope.loadPoint.LoadPointTanks.forEach(function (loadPointTank) {
            if(loadPointTank.TankId == null){
                $scope.modelState[$scope.modelState.length] = "Tank ID is required for bulk plant tank " + loadPointTank.Id
            }
            else if(loadPointTank.TankId.length > 50) {
                $scope.modelState[$scope.modelState.length] = "Tank ID has more than 50 characters for bulk plant tank " + loadPointTank.Id
            }
            if(loadPointTank.ProductId == null){
                $scope.modelState[$scope.modelState.length] = "Product is required for bulk plant tank " + loadPointTank.Id
            }
            if(loadPointTank.Barcode && loadPointTank.Barcode.length > 50) {
                $scope.modelState[$scope.modelState.length] = "Barcode has more than 50 characters for bulk plant tank " + loadPointTank.Id
            }
            if($scope.modelState.length > 0)
                return;
            if (loadPointTank.LoadLocationId == null) {
                loadPointTank.LoadLocationId = $scope.loadPoint.Id;
                loadPointTank.Id = id;
                id--;
            }
        });

        if($scope.modelState.length > 0) {
            scrollToTop();
            return;
        }

        LoadPointFactory.saveLoadPoint($scope.loadPoint).success(function (loadPointId) {
            LoadPointFactory.getLoadPointList($rootScope.accessToken).success(function (data) {
                var dataGrid = $('#gridloadPoint').dxDataGrid('instance');
                pageindex = dataGrid.pageIndex();
                $scope.pageSize = dataGrid.pageSize();
                $scope.loadPoints = data;
                if ($scope.loadPoint.Id > 0) {
                    $scope.refreshGrid(pageindex)
                }
                else {
                    $scope.cancelForm();
                    $scope.refreshGrid(pageindex);
                }
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
                scrollToTop();
            }).finally(function (data) {
                if ($scope.loadPoint.Id > 0) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Load Point successfully' });
                }
                else {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Load Point successfully' });
                }
            });            
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
            scrollToTop();
        });
    };

    $scope.addNewLoadPointTank = function () {
        var dataGrid = $('#gridBulkPlantTank').dxDataGrid('instance');
        var len = 0;
        var id = 1;
        if ($scope.loadPoint.LoadPointTanks != null)
            len = $scope.loadPoint.LoadPointTanks.length;
        if (len > 0) {
            $scope.loadPoint.LoadPointTanks.forEach(function (loadPointTank) {
                if (loadPointTank.Id >= id)
                    id = loadPointTank.Id + 1;
            });
        }
        $scope.loadPointTank = {};
        $scope.loadPointTank.Id = id;
        $scope.loadPointTank.Deleted = false
        $scope.loadPointTank.Changed = true;
        $scope.loadPoint.LoadPointTanks[len] = $scope.loadPointTank;

        dataGrid.refresh();
        (dataGrid as unknown as FacnmDx).selectRows($scope.loadPointTank);
    };

    $scope.onLoadPointTankChange = function () {
        var dataGrid = $('#gridBulkPlantTank').dxDataGrid('instance');
        var selectedKey = dataGrid.getSelectedRowKeys();
        var selectedRows = dataGrid.getSelectedRowsData();
        var index = $scope.loadPoint.LoadPointTanks.indexOf(selectedRows[0]);

        if($scope.loadPointTank.ProductId)
            $scope.loadPointTank.ProductName = $scope.productDropdown.filter(function(item){return item.Id===$scope.loadPointTank.ProductId})[0].ProductName;

        $scope.loadPointTank.Changed = true;
        $scope.loadPoint.LoadPointTanks[index] = $scope.loadPointTank;
        dataGrid.refresh();
        (dataGrid as unknown as FacnmDx).selectRows(selectedKey, true);
    };

    $scope.viewProductList = function () {
        $uibModal.open({
            templateUrl: 'app-legacy/Entities/templates/defaultCustomerModel.html',
            controller: 'ProductListController',
            size: 'lg',
            scope: $scope,
            windowTemplateUrl: 'app-legacy/Entities/templates/modal-scrollable-content.html'
        }).result.then(function () {
            $scope.loadPointTank.ProductId = $rootScope.user.ProductId;
            $scope.onLoadPointTankChange();
        }).catch(function () {
        });
    };

    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridloadPoint', settings.GridMarginHeight);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridloadPoint', settings.GridMarginHeight);
    };

    collapsibleHeaderClickEvent($scope);

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

    $scope.closeAlert = function () {
        $scope.error = null;
    };

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    init(0);
});
